export default "__VITE_ASSET__BqAfr4sO__"